export class UniverCardModel {
  id: string = ''
  name: string = ''
  image: string = ''
  studyDuration: string = ''
  studyPrice: string = ''
  // eslint-disable-next-line camelcase
  short_name: string = ''
  logo: string = ''
}
